module.exports = window.__qiankun__;